<template>
    <div class='logo-container' @click='goToHome'>
        <DynamicImageContainer class="logo" :image='logo' :use_random_test_images='false'/>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {DynamicImageContainer},
    data(){
        return{
            logo: 'logos/itim_shop_logo.svg'
        }
    },
    methods:{
        goToHome(){
            this.$router.push('/');
        }
    }
}
</script>

<style lang="scss" scoped>
.logo-container{
    padding: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.logo{
    width: auto;
    
    @media(max-width: 768px){
        width: 120px;
    }
}
</style>